import React from "react";
import cx from "clsx";
import { Button } from "../../../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import styles from "./subscriptionCard.module.scss";
import { usePrices } from "../../hooks/usePrices";
import { CHARTSMART_PLAN } from "../../../../../../consts/ChartSmart";

export function SubscriptionCard({ planName, selectedPlan, onSelectPlan }) {
  const { tSettings } = useAppTranslation.Settings();
  const { data: user } = useCurrentUserQuery();
  const { getPrice, getLimit } = usePrices();

  const price = getPrice(planName);
  const isActive = selectedPlan === planName;
  const currency = user?.currencySymbol;

  const frequencyMap = {
    [CHARTSMART_PLAN.payg]: "Chart",
    [CHARTSMART_PLAN.starter]: "Month",
    [CHARTSMART_PLAN.pro]: "Month",
    [CHARTSMART_PLAN.unlimited]: "Month",
  };

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.active]: isActive,
      })}
    >
      <div className={styles.card}>
        <h5 className={styles.title}>
          {tSettings(`subscriptions.chartSmart.${planName}`)}
        </h5>
        <div>
          <div>
            {currency}
            {price} per {frequencyMap[planName]}
          </div>
          {planName !== CHARTSMART_PLAN.payg && (
            <div className={styles.bold}>
              {tSettings(`subscriptions.chartSmart.description.upTo`, {
                limit:
                  planName === CHARTSMART_PLAN.unlimited
                    ? "unlimited"
                    : getLimit(planName),
              })}
            </div>
          )}
          <div className={styles.descSmall}>
            {tSettings(`subscriptions.chartSmart.description.${planName}`)}
          </div>
        </div>
      </div>
      <Button
        size="small"
        color={isActive ? "black" : "primary"}
        variant={isActive ? "outlined" : "contained"}
        className={cx(styles.button, {
          [styles.activeButton]: isActive,
        })}
        onClick={() => onSelectPlan(planName)}
      >
        {isActive
          ? tSettings("subscriptions.chartSmart.selectedPlan")
          : tSettings("subscriptions.chartSmart.selectPlan")}
      </Button>
    </div>
  );
}
